import React from "react";
import { useDispatch } from "react-redux";
import Button from "@material-ui/core/Button";
import AnalyzeCollectionDialog from "../AnalyzeCollectionDialog/AnalyzeCollectionDialog";
import { getOrderByNumero } from "../../../../../state/order/actions";
import {
  isAwaitingStoreConfirmation,
  isAwaitingSAL,
} from "../../utils/orderStatus";
import useStyles from "./ReadyToGoDetailAlert.styles";

function EmergencyIcon(props) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M16.0001 29.3667C15.6446 29.3667 15.3057 29.3 14.9835 29.1667C14.6612 29.0333 14.3668 28.8445 14.1001 28.6L3.40013 17.9C3.15569 17.6333 2.9668 17.3389 2.83346 17.0167C2.70013 16.6945 2.63346 16.3556 2.63346 16C2.63346 15.6445 2.70013 15.3 2.83346 14.9667C2.9668 14.6333 3.15569 14.3445 3.40013 14.1L14.1001 3.40001C14.3668 3.13334 14.6612 2.9389 14.9835 2.81667C15.3057 2.69445 15.6446 2.63334 16.0001 2.63334C16.3557 2.63334 16.7001 2.69445 17.0335 2.81667C17.3668 2.9389 17.6557 3.13334 17.9001 3.40001L28.6001 14.1C28.8668 14.3445 29.0612 14.6333 29.1835 14.9667C29.3057 15.3 29.3668 15.6445 29.3668 16C29.3668 16.3556 29.3057 16.6945 29.1835 17.0167C29.0612 17.3389 28.8668 17.6333 28.6001 17.9L17.9001 28.6C17.6557 28.8445 17.3668 29.0333 17.0335 29.1667C16.7001 29.3 16.3557 29.3667 16.0001 29.3667ZM14.6668 17.3333H17.3335V9.33334H14.6668V17.3333ZM16.0001 21.3333C16.3779 21.3333 16.6946 21.2056 16.9501 20.95C17.2057 20.6945 17.3335 20.3778 17.3335 20C17.3335 19.6222 17.2057 19.3056 16.9501 19.05C16.6946 18.7945 16.3779 18.6667 16.0001 18.6667C15.6224 18.6667 15.3057 18.7945 15.0501 19.05C14.7946 19.3056 14.6668 19.6222 14.6668 20C14.6668 20.3778 14.7946 20.6945 15.0501 20.95C15.3057 21.2056 15.6224 21.3333 16.0001 21.3333Z"
        fill="#FFB21C"
      />
    </svg>
  );
}

function InfoBadgeIcon(props) {
  return (
    <svg
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M14.6667 22.6667H17.3333V14.6667H14.6667V22.6667ZM16.95 11.6167C17.2056 11.3611 17.3333 11.0444 17.3333 10.6667C17.3333 10.2889 17.2056 9.97222 16.95 9.71667C16.6944 9.46111 16.3778 9.33333 16 9.33333C15.6222 9.33333 15.3056 9.46111 15.05 9.71667C14.7944 9.97222 14.6667 10.2889 14.6667 10.6667C14.6667 11.0444 14.7944 11.3611 15.05 11.6167C15.3056 11.8722 15.6222 12 16 12C16.3778 12 16.6944 11.8722 16.95 11.6167ZM16 29.3333C14.1556 29.3333 12.4222 28.9833 10.8 28.2833C9.17778 27.5833 7.76667 26.6333 6.56667 25.4333C5.36667 24.2333 4.41667 22.8222 3.71667 21.2C3.01667 19.5778 2.66667 17.8444 2.66667 16C2.66667 14.1556 3.01667 12.4222 3.71667 10.8C4.41667 9.17778 5.36667 7.76667 6.56667 6.56667C7.76667 5.36667 9.17778 4.41667 10.8 3.71667C12.4222 3.01667 14.1556 2.66667 16 2.66667C17.8444 2.66667 19.5778 3.01667 21.2 3.71667C22.8222 4.41667 24.2333 5.36667 25.4333 6.56667C26.6333 7.76667 27.5833 9.17778 28.2833 10.8C28.9833 12.4222 29.3333 14.1556 29.3333 16C29.3333 17.8444 28.9833 19.5778 28.2833 21.2C27.5833 22.8222 26.6333 24.2333 25.4333 25.4333C24.2333 26.6333 22.8222 27.5833 21.2 28.2833C19.5778 28.9833 17.8444 29.3333 16 29.3333Z"
        fill="#4056C7"
      />
    </svg>
  );
}

export default function ReadyToGoDetailAlert({ order }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const [open, setOpen] = React.useState(false);

  if (isAwaitingStoreConfirmation(order)) {
    return (
      <>
        <div className={`${classes.box} ${classes.warning}`}>
          <div className={classes.content}>
            <EmergencyIcon className={classes.icon} />
            <div className={classes.text}>
              <span className={classes.title}>
                Recebemos o status de entregue para esse pedido, mas a coleta
                não foi confirmada.
              </span>
              <span className={classes.subtitle}>
                Analise a retirada do pedido e, caso não tenha sido coletado,
                entre em contato com o SAL.
              </span>
            </div>
          </div>

          <Button
            className={classes.analyzeButton}
            variant="contained"
            onClick={() => setOpen(true)}
          >
            Analisar
          </Button>
        </div>

        <AnalyzeCollectionDialog
          open={open}
          pedido={order}
          onClose={() => setOpen(false)}
          onConfirm={() => dispatch(getOrderByNumero(order.numero, true))}
        />
      </>
    );
  }

  if (isAwaitingSAL(order)) {
    return (
      <div className={`${classes.box} ${classes.info}`}>
        <div className={classes.content}>
          <InfoBadgeIcon className={classes.icon} />
          <div className={classes.text}>
            <span className={classes.title}>
              Recebemos a confirmação de entrega para este pedido, mas ele não
              saiu da loja.{" "}
              <span className={classes.bold}>
                Entre em contato com o SAL para analisar o caso.
              </span>
            </span>
          </div>
        </div>
      </div>
    );
  }

  return null;
}
